import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import HomeDashboard from './pages/home-dashboard';
import OnboardingDashboard from './pages/onboarding-dashboard';
import ARScannerInterface from './pages/ar-scanner-interface';
import RetailPartnerPortal from './pages/retail-partner-portal';
import AdminManagementDashboard from './pages/admin-management-dashboard';
import BudgetManager from './pages/budget-manager';
import SpendingInsightsDashboard from './pages/spending-insights-dashboard';
import FinancialGoals from './pages/financial-goals';
import SettingsProfile from './pages/settings-profile';
import PartnerOnboardingWizard from './pages/partner-onboarding-wizard';
import { useAuth } from './contexts/AuthContext';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#020617] flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 rounded-full border-2 border-[#06B6D4] border-t-transparent animate-spin" />
          <p className="text-[#94A3B8] text-sm">Loading...</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/onboarding-dashboard" replace />;
  return children;
}

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<Navigate to="/onboarding-dashboard" replace />} />
          <Route path="/onboarding-dashboard" element={<OnboardingDashboard />} />
          <Route path="/home-dashboard" element={<ProtectedRoute><HomeDashboard /></ProtectedRoute>} />
          <Route path="/ar-scanner-interface" element={<ProtectedRoute><ARScannerInterface /></ProtectedRoute>} />
          <Route path="/budget-manager" element={<ProtectedRoute><BudgetManager /></ProtectedRoute>} />
          <Route path="/spending-insights-dashboard" element={<ProtectedRoute><SpendingInsightsDashboard /></ProtectedRoute>} />
          <Route path="/financial-goals" element={<ProtectedRoute><FinancialGoals /></ProtectedRoute>} />
          <Route path="/settings-profile" element={<ProtectedRoute><SettingsProfile /></ProtectedRoute>} />
          <Route path="/retail-partner-portal" element={<RetailPartnerPortal />} />
          <Route path="/partner-onboarding-wizard" element={<PartnerOnboardingWizard />} />
          <Route path="/admin-management-dashboard" element={<AdminManagementDashboard />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
